module.exports = __webpack_public_path__ + "static/media/001-man.be1c75f9.svg";